const Others = () => {
  return <div>Others Screen</div>;
};

export default Others;
